/** The task application's explicit cross-language title contract. */
export function normalizeTitle(value: string) {
  return value.replace(/^[ \t\r\n]+|[ \t\r\n]+$/g, '');
}

export function validTitle(value: string) {
  const characters = Array.from(normalizeTitle(value));
  return (
    characters.length >= 1 &&
    characters.length <= 80 &&
    characters.every((character) => {
      const point = character.codePointAt(0) ?? 0;
      return point < 0xd800 || point > 0xdfff;
    })
  );
}
